import $ from "jquery";

const openModal = () => {
  const el = {
    button: ".main-footer .js-btn-inschrijven",
    buttonClose: ".modal-inschrijven .js-btn-close",
    modal: ".modal-inschrijven",
    overlay: ".modal-inschrijven .background-overlay",
  };
  
  $(() => {
    if ($(el.button).length === 0) return;

    $(el.button).on("click", () => {
      $(el.modal).addClass("show");
      $("body").addClass("hidden");
    });
    $(el.overlay).on("click", () => {
      $(el.modal).removeClass("show");
      $("body").removeClass("hidden");
    });
    $(el.buttonClose).on("click", () => {
      $(el.modal).removeClass("show");
      $("body").removeClass("hidden");
    });
  });
};

const wpmlBanner = () => {
  const el = {
    banner: ".otgs-development-site-front-end",
  };
  $(document).ready(function () {
    $(el.banner).hide();
  });
};

try {
  openModal();
  wpmlBanner();
} catch (error) {
  // eslint-disable-next-line no-console
  console.log(error);
}
